module.exports = __webpack_public_path__ + "media/components/lessons/statics/lesson5-286467ac9be8d3663de07febe29d7acc.gif";